import React from "react";
import styled, { keyframes } from "styled-components";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import { Row } from "react-bootstrap";
import ComponentHeader from "../Header/ComponentHeader";
import Piechart from "./../Charts/PieChart";
import DoubleBar from "../Elements/DoubleBar";
import { useInView } from "react-intersection-observer";
// import { fadeIn, slideInUp } from "react-animations";
import BubbleFlexSvg from "../Elements/BubbleFlexSvg";
import { HeadingMunicipality, FiguresWrapper } from "../../Util/StyleProps";
import { primaryColor, secondaryColor,oppositeColor,mainColor } from "../../Util/Colors";
import { valuePairToPercent } from "../../Helpers/CommonHelper";
import EmptySpace from "../Elements/EmptySpace";

// const slideInAnimation = keyframes`${slideInUp}`;
// const fadeInAnimation = keyframes`${fadeIn}`;

const GenderContainer = props => {
    const [ref, inView, entry] = useInView({
      /* Optional options */
      threshold: 0,
      triggerOnce: true
    });
  const { data, sweden, blockColor, scroll } = props;

  let valueData = [];
  let swedenArr, swedenString;

  const lastYear = sweden && sweden.gender ? sweden.gender.year : "";
  swedenArr = valuePairToPercent(sweden.gender, ["male", "female"], 1);
  swedenString =
    "I Sverige är " +
    swedenArr.pstring2 +
    " procent kvinnor och " +
    swedenArr.pstring1 +
    " procent män (" +
    lastYear +
    ").";

  data.forEach((item, i) => {
    if (item) {
      valueData.push(valuePairToPercent(item, ["male", "female"], 1));
    }
  });

  let municipality1 = valueData[0];
  let municipality2 = valueData[1];

  // Accessibility
  const ariaLabel = municipality =>
    municipality
      ? `I ${municipality.name} kommun finns det ${municipality.pstring2} procent kvinnor och ${municipality.pstring1} procent män.`
      : "";

  const svgAriaLabel = municipality =>
    municipality
      ? `Det här pajdiagrammet jämför antalet kvinnor och män i ${municipality.name} kommun.`
      : "";

  //Attention values and labels in this component is mixed to match position of pie elements
  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
      <svg style={{ marginBottom: "32px"}} xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path d="M18.9492 72.5V48.3333H14.5575V29.5258C14.5575 28.0642 15.085 26.8056 16.14 25.75C17.195 24.6944 18.4361 24.1667 19.8633 24.1667H28.4117C29.8594 24.1667 31.1111 24.6944 32.1667 25.75C33.2222 26.8056 33.75 28.0642 33.75 29.5258V48.3333H29.3592V72.5H18.9492ZM24.1617 19.9233C22.5756 19.9233 21.2225 19.3661 20.1025 18.2517C18.9831 17.1372 18.4233 15.7869 18.4233 14.2008C18.4233 12.6142 18.9803 11.2608 20.0942 10.1408C21.2086 9.02139 22.5592 8.46167 24.1458 8.46167C25.7325 8.46167 27.0856 9.01889 28.205 10.1333C29.325 11.2472 29.885 12.5975 29.885 14.1842C29.885 15.7708 29.3278 17.1239 28.2133 18.2433C27.0989 19.3633 25.7483 19.9233 24.1617 19.9233ZM52.66 72.5V53.3333H44.6025L51.2242 27.7692C51.5608 26.6297 52.2039 25.7444 53.1533 25.1133C54.1022 24.4822 55.2081 24.1667 56.4708 24.1667C57.7336 24.1667 58.8344 24.4822 59.7733 25.1133C60.7117 25.7444 61.3492 26.6297 61.6858 27.7692L68.34 53.3333H60.25V72.5H52.66ZM56.4633 19.9233C54.8767 19.9233 53.5236 19.3661 52.4042 18.2517C51.2842 17.1372 50.7242 15.7869 50.7242 14.2008C50.7242 12.6142 51.2814 11.2608 52.3958 10.1408C53.5103 9.02139 54.8605 8.46167 56.4467 8.46167C58.0333 8.46167 59.3867 9.01889 60.5067 10.1333C61.6261 11.2472 62.1858 12.5975 62.1858 14.1842C62.1858 15.7708 61.6286 17.1239 60.5142 18.2433C59.4003 19.3633 58.05 19.9233 56.4633 19.9233Z" fill="#1F44FF"/>
        <path d="M52.66 72.5V53.3333H44.6025L51.2242 27.7692C51.5609 26.6297 52.2039 25.7445 53.1534 25.1133C54.1023 24.4822 55.2081 24.1667 56.4709 24.1667C57.7337 24.1667 58.8345 24.4822 59.7734 25.1133C60.7117 25.7445 61.3492 26.6297 61.6859 27.7692L68.34 53.3333H60.25V72.5H52.66ZM56.4634 19.9233C54.8767 19.9233 53.5236 19.3661 52.4042 18.2517C51.2842 17.1372 50.7242 15.7869 50.7242 14.2008C50.7242 12.6142 51.2814 11.2608 52.3959 10.1408C53.5103 9.02139 54.8606 8.46167 56.4467 8.46167C58.0334 8.46167 59.3867 9.01889 60.5067 10.1333C61.6262 11.2472 62.1859 12.5975 62.1859 14.1842C62.1859 15.7708 61.6287 17.1239 60.5142 18.2433C59.4003 19.3633 58.05 19.9233 56.4634 19.9233Z" fill="#0F0865"/>
      </svg>
        <ComponentHeader
          heading={"Så ser könsfördelningen ut"}
          text={swedenString}
        />
        {municipality1 ? (
          <div ref={ref}>
            <FiguresWrapper maxWidth="900px">
            {municipality1 ? (
              <div style={{ display: "flex", flexDirection: "column", placeContent: "space-between", minWidth: "47%" }}>
                <HeadingMunicipality
                  aria-label={ariaLabel(municipality1)}
                  marginBottom="24px"
                >
                  {municipality1.name}
                </HeadingMunicipality>
                <DoubleBar
                  bar1={{
                    color: mainColor,
                    value: `${municipality1.pstring2}%`,
                    label: "Kvinnor",
                    height: inView ? `${municipality1.value2 > 0 ? 300 * municipality1.value2 / 100 : 0}px` : "0px",
                    lineColor: mainColor
                  }}
                  bar2={{
                    color: mainColor,
                    value: `${municipality1.pstring1}%`,
                    label: "Män",
                    height: inView ? `${municipality1.value1 > 0 ? 300 * municipality1.value1 / 100 : 0}px` : "0px",
                    lineColor: mainColor
                  }}
                  inView={inView}
                />
              </div>
            ) : (
              <div></div>
            )}
            {municipality2 ? (
              <div style={{ display: "flex", flexDirection: "column", placeContent: "space-between", minWidth: "47%" }}>
                <HeadingMunicipality
                  aria-label={ariaLabel(municipality2)}
                  color={secondaryColor}
                  marginBottom="24px"
                >
                  {municipality2.name}
                </HeadingMunicipality>
                <DoubleBar
                  bar1={{
                    color: oppositeColor,
                    value: `${municipality2.pstring2}%`,
                    label: "Kvinnor",
                    height: inView ? `${municipality2.value2 > 0 ? 300 * municipality2.value2 / 100 : 0}px` : "0px",
                    lineColor: oppositeColor
                  }}
                  bar2={{
                    color: oppositeColor,
                    value: `${municipality2.pstring1}%`,
                    label: "Män",
                    height: inView ? `${municipality2.value1 > 0 ? 300 * municipality2.value1 / 100 : 0}px` : "0px",
                    lineColor: oppositeColor
                  }}
                  inView={inView}
                />
              </div>
              
            ) : (
              <SvgLayout>
                <EmptySpace scroll={scroll} />
              </SvgLayout>
            )}
            </FiguresWrapper>
          </ div>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};


GenderContainer.defaultProps = {
  data: [],
  sweden: {}
};

export default GenderContainer;
